import React, { PureComponent } from 'react'
import './style.scss'
import {emptyArrCleaner} from '../../helpers'
import * as _ from 'lodash'
import { base, statuses } from '../../../config'
import BigCalendar from 'react-big-calendar'
import Filters from '../../components/Filters'
import moment from 'moment'
import JobSorter from '../../components/JobSorter'
BigCalendar.momentLocalizer(moment)
import {browserHistory} from 'react-router'
let allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k])

class Calendar extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      jobs: [],
      filter: ['quote', 'confirmed', 'invoiced', 'paid'],
      currentDate: new Date()
    }
  }

  componentDidMount () {
    const _this = this
    this.ref = base.syncState(`user_details/${this.props.uid}/jobs`, {
        context: this,
        state: 'jobs',
        asArray: true,
        then() {}
    })
  }

  select (event) {
    browserHistory.push(`/job/${event.key}/tabs-view`);
  }

  _filter (filter, check) {
    let filteredAry = []
    if (check) {
      filteredAry = this.state.filter.filter(function(e) { return e !== filter })
    }
    if (!check) {
      let fil = this.state.filter
      fil.push(filter)
      filteredAry = fil
    }
    this.setState({filter: filteredAry})
  }

  render () {

    const events = this.state.jobs.map((item, i) => {
      const sale = item.total && item.total.sale ? item.total.sale : 0
      const cost = item.total && item.total.cost ? item.total.cost : 0
      return {
        id: i,
        title: `${item.selected_status.label} - ${item.label} £${Number(sale) - Number(cost)}`,
        start: new Date(item.start),
        end: new Date(item.end),
        selected_status: item.selected_status,
        key: item.key,
        total: {
          cost: cost,
          sale: sale
        }
      }
    })

    let filteredEvents = events

    if (this.state.filter !== 'all') filteredEvents = filteredEvents.filter((job) => {
      if (this.state.filter.includes(job.selected_status.value)) return job
    })

    const filters = statuses.map((item, index) => {
      const active = this.state.filter === item.value ? 'active' : ''
      return (
        <div key={index} className="btn-group" role="group">
          <button key={`filter${index}`} onClick={this._filter.bind(this, item.value)} type="button" className={`btn ${item.class} ${active}`}>{item.label}</button>
        </div>
      )
    })

    const totalCost = filteredEvents.map(item => {return item.total && item.total.cost ? item.total.cost : 0}).reduce((a, b) => Number(a) + Number(b), 0)
    const totalSale = filteredEvents.map(item => {return item.total && item.total.sale ? item.total.sale : 0}).reduce((a, b) => Number(a) + Number(b), 0)
    const totalProfit = totalSale - totalCost

    return (
      <div className='calendar with-sidebar main-pt full-width-page'>
        <div className='row'>

          <div className="col-sm-4 col-md-3 ">
            <JobSorter
                profit={totalProfit}
                cost={totalCost}
                sale={totalSale}
                showFilter
               _filter={this._filter.bind(this)}
               filter={this.state.filter}
            />
          </div>


          <div className='col-sm-8 col-md-9'>
            <div className='panel'>
              <div className='panel-body'>
                <BigCalendar
                    step={60}
                    ref='calendar'
                    views={['month']}
                    events={filteredEvents}
                    onSelectEvent={this.select.bind(this)}
                    defaultDate={new Date()}
                    onNavigate={(date, view) => {
                      //this.onNav(date)
                    }}
                    eventPropGetter={
                      (event, start, end, isSelected) => {
                        // let newStyle = {
                        //   // backgroundColor: "lightgrey",
                        //   // color: 'black',
                        //   // borderRadius: "0px",
                        //   // border: "none"
                        // }
                        return {
                          className: event.selected_status.class
                        }
                      }
                    }
                 />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Calendar



// WEBPACK FOOTER //
// ./src/views/pages/Calendar/index.js